const APP_CONFIG = {
  account_types: {
    1: "Internal",
    2: "Live",
  },
  account_status_opt: {
    1: "Active",
    0: "Inactive",
  },
  market_iq_demo: "8",
  growth_iq_user_roles: {
    ROLE_MNM_SUBSCRIBER: "Super admin",
    ROLE_ACCOUNT_MANAGER: "Account manager",
    ROLE_SUBSCRIBER_ADMIN: "Client admin",
    ROLE_SUBSCRIBER_EMPLOYEE: "Client employee",
  },
  region_options: {
    north_america: "North America",
    europe: "Europe",
    asiapacific: "Asia-Pacific",
    middle_east_africa: "Middle East & Africa",
    south_america: "South America",
  },
  country_options: {
    AF: "Afghanistan",
    AX: "Aland Islands",
    AL: "Albania",
    DZ: "Algeria",
    AS: "American Samoa",
    AD: "Andorra",
    AO: "Angola",
    AI: "Anguilla",
    AG: "Antigua and Barbuda",
    AR: "Argentina",
    AM: "Armenia",
    AW: "Aruba",
    AU: "Australia",
    AT: "Austria",
    AZ: "Azerbaijan",
    BS: "Bahamas",
    BH: "Bahrain",
    BD: "Bangladesh",
    BB: "Barbados",
    BY: "Belarus",
    BE: "Belgium",
    BZ: "Belize",
    BJ: "Benin",
    BM: "Bermuda",
    BT: "Bhutan",
    BO: "Bolivia",
    BA: "Bosnia and Herzegovina",
    BW: "Botswana",
    BR: "Brazil",
    VG: "British Virgin Islands",
    BN: "Brunei",
    BG: "Bulgaria",
    BF: "Burkina Faso",
    BI: "Burundi",
    KH: "Cambodia",
    CM: "Cameroon",
    CA: "Canada",
    CV: "Cape Verde",
    KY: "Cayman Islands",
    CF: "Central African Republic",
    TD: "Chad",
    CL: "Chile",
    CN: "China",
    CX: "Christmas Island",
    CO: "Colombia",
    KM: "Comoros",
    CR: "Costa Rica",
    CI: "Cote D'Ivoire",
    HR: "Croatia",
    CU: "Cuba",
    CY: "Cyprus",
    CZ: "Czech Republic",
    CG: "Democratic Republic Of The Congo",
    DK: "Denmark",
    DJ: "Djibouti",
    DM: "Dominica",
    DO: "Dominican Republic",
    EC: "Ecuador",
    EG: "Egypt",
    SV: "El Salvador",
    GQ: "Equatorial Guinea",
    ER: "Eritrea",
    EE: "Estonia",
    SZ: "Eswatini",
    ET: "Ethiopia",
    FM: "Federated States Of Micronesia",
    FJ: "Fiji",
    FI: "Finland",
    FR: "France",
    GA: "Gabon",
    GM: "Gambia",
    GE: "Georgia",
    DE: "Germany",
    GH: "Ghana",
    GR: "Greece",
    GD: "Grenada",
    GT: "Guatemala",
    GN: "Guinea",
    GW: "Guinea-Bissau",
    GY: "Guyana",
    HT: "Haiti",
    HN: "Honduras",
    HK: "Hong Kong",
    HU: "Hungary",
    IS: "Iceland",
    IN: "India",
    ID: "Indonesia",
    IR: "Iran",
    IQ: "Iraq",
    IE: "Ireland",
    IL: "Israel",
    IT: "Italy",
    JM: "Jamaica",
    JP: "Japan",
    JO: "Jordan",
    KZ: "Kazakhstan",
    KE: "Kenya",
    KI: "Kiribati",
    XK: "Kosovo",
    KW: "Kuwait",
    KG: "Kyrgyzstan",
    LA: "Laos",
    LV: "Latvia",
    LB: "Lebanon",
    LS: "Lesotho",
    LR: "Liberia",
    LY: "Libya",
    LI: "Liechtenstein",
    LT: "Lithuania",
    LU: "Luxembourg",
    MK: "Macedonia",
    MG: "Madagascar",
    MW: "Malawi",
    MY: "Malaysia",
    MV: "Maldives",
    ML: "Mali",
    MT: "Malta",
    MH: "Marshall Islands",
    MR: "Mauritania",
    MU: "Mauritius",
    MX: "Mexico",
    MD: "Moldova",
    MC: "Monaco",
    MN: "Mongolia",
    ME: "Montenegro",
    MA: "Morocco",
    MZ: "Mozambique",
    MM: "Myanmar",
    NA: "Namibia",
    NR: "Nauru",
    NP: "Nepal",
    NL: "Netherlands",
    NZ: "New Zealand",
    NI: "Nicaragua",
    NE: "Niger",
    NG: "Nigeria",
    KP: "North Korea",
    PS: "North Macedonia",
    NO: "Norway",
    OM: "Oman",
    PK: "Pakistan",
    PW: "Palau",
    PS: "Palestine",
    PA: "Panama",
    PG: "Papua New Guinea",
    PY: "Paraguay",
    PE: "Peru",
    PH: "Philippines",
    PL: "Poland",
    PT: "Portugal",
    QA: "Qatar",
    CG: "Republic Of The Congo",
    RO: "Romania",
    RU: "Russia",
    RW: "Rwanda",
    KN: "Saint Kitts and Nevis",
    LC: "Saint Lucia",
    VC: "Saint Vincent and Grenadines",
    WS: "Samoa",
    SM: "San Marino",
    ST: "Sao Tome and Principe",
    SA: "Saudi Arabia",
    SN: "Senegal",
    RS: "Serbia",
    SC: "Seychelles",
    SL: "Sierra Leone",
    SG: "Singapore",
    SK: "Slovakia",
    SI: "Slovenia",
    SB: "Solomon Islands",
    SO: "Somalia",
    ZA: "South Africa",
    KR: "South Korea",
    SS: "South Sudan",
    ES: "Spain",
    LK: "Sri Lanka",
    SD: "Sudan",
    SR: "Suriname",
    SE: "Sweden",
    CH: "Switzerland",
    SY: "Syria",
    TW: "Taiwan",
    TJ: "Tajikistan",
    TZ: "Tanzania",
    TH: "Thailand",
    TL: "Timor-Leste",
    TG: "Togo",
    TK: "Tokelau",
    TO: "Tonga",
    TT: "Trinidad and Tobago",
    TN: "Tunisia",
    TR: "Turkey",
    TM: "Turkmenistan",
    TC: "Turks and Caicos Islands",
    TV: "Tuvalu",
    VI: "U.S. Virgin Islands",
    UG: "Uganda",
    UA: "Ukraine",
    AE: "United Arab Emirates",
    GB: "United Kingdom",
    US: "United States",
    UM: "United States Minor Outlying Islands",
    UY: "Uruguay",
    UZ: "Uzbekistan",
    VU: "Vanuatu",
    VA: "Vatican City",
    VE: "Venezuela",
    VN: "Vietnam",
    WF: "Wallis and Futuna Islands",
    EH: "Western Sahara",
    YE: "Yemen",
    ZM: "Zambia",
    ZW: "Zimbabwe",
  },
  company_domains: {
    "Aerospace & Defence": "Aerospace & Defence",
    Agriculture: "Agriculture",
    "Automotive & Transportation": "Automotive & Transportation",
    "Chemicals & Material": "Chemicals & Material",
    "Energy & Power": "Energy & Power",
    "Food & Beverage": "Food & Beverage",
    Healthcare: "Healthcare",
    "Information & Communications Technology":
      "Information & Communications Technology",
    "Packaging, Construction, Mining & Gases":
      "Packaging, Construction, Mining & Gases",
    "Private Equity/Financial Services": "Private Equity/Financial Services",
    "Research Institute/University": "Research Institute/University",
    "Research/Consulting/Business Services":
      "Research/Consulting/Business Services",
    "Semiconductor & Electronics": "Semiconductor & Electronics",
  },
  user_roles: {
    24: "Super Admin",
    25: "Analyst",
    26: "Client",
  },
  user_status_options: {
    1: "Active",
    0: "Inactive",
  },
  AVATAR_URL: "https://ui-avatars.com/api/?",
  randomIconClasses: [
    "purple_strat",
    "green_strat",
    "magenta_strat",
    "orange_strat",
    "blue_strat",
  ],
  randomBarClasses: ["purple", "green", "yellow", "magenta"],
  defaultCategories: [
    {
      name: "Corporate & Org Structure",
      subDimensions: [
        "Company Overview",
        "Headquarters & Business Segments",
        "Ownership & Structure",
        "Executive Team & Key Leadership",
        "Workforce & Hiring Trends",
      ],
    },
    {
      name: "Financial Performance & Strategy",
      subDimensions: [
        "Headline Financial Metrics",
        "Pricing & Cost Structures",
        "Investor Guidance & Board Commentary",
        "Revenue Breakdown",
      ],
    },
    {
      name: "Market Position & Intelligence",
      subDimensions: [
        "End User / Customer Segment Penetration",
        "Industry & Segment Reach",
        "Key Expansions & Emerging Strategic Bets",
        "Recent Strategic Customer Wins",
        "Trending Industry Signals",
        "Customer Overlap Risk Zones",
      ],
    },
    {
      name: "Product & Innovation",
      subDimensions: [
        "Portfolio Composition",
        "Features & Differentiators",
        "Performance & Adoption",
        "Patent Portfolio",
        "Patent Licensing & Collaborations",
        "Launch Timelines & Regions",
        "Adoption & Market Response",
      ],
    },
    {
      name: "Marketing & Distribution",
      subDimensions: [
        "Advertising & Media Spend",
        "Messaging & Positioning",
        "Digital Footprint Analysis",
        "Pricing Models & Bundling",
        "Distribution Model",
      ],
    },
    {
      name: "Operations & Supply Chain",
      subDimensions: [
        "Logistics & Delivery Performance",
        "Operational Efficiency Metrics",
      ],
    },
  ],
  competitorProfileCategories: [
    {
      name: "Executive Snapshot",
      subDimensions: [
        "Overall Competitive Threat Assessment",
        "Executive Summary Next Steps",
        "Company Overview",
        "OpsSupply ScoreCard",
        "MarketingDistributions ScoreCard",
        "FinancialsStrategy ScoreCard",
        "MarketPosition ScoreCard",
        "OrgLeader ScoreCard",
        "ProdInno ScoreCard",
        "Business Segment",
      ],
    },
    {
      name: "Market Position & Customer Intelligence",
      subDimensions: [
        "Market by application",
        "Market by technology",
        "Market by geography",
        "Key Expansions & Strategic Initiatives",
        "Market Share Analysis",
        "Customer Segment Analysis",
      ],
    },
    {
      name: "Product & Innovation",
      subDimensions: [
        "Product & Solution Portfolio",
        "Patents & IP Activity",
        "R&D Spend Estimates",
        "Innovation Theme Radar",
        "Product Launches & Related Activities",
        "Technology Capability Assessment",
      ],
    },
    {
      name: "Strategy & Financial Performance",
      subDimensions: [
        "Financial Performance",
        "Future Bets",
        "Financial Documents",
        "Strategic Themes",
      ],
    },
    {
      name: "Marketing & Distribution",
      subDimensions: [
        "GTM & Distribution Strategy Analysis",
        "Marketing Geographic Coverage",
        "Digital Footprint Analysis",
        "Messaging & Positioning",
        "Market Presence & Brand Signals",
        "Demand Generation & Acquisition Tactics",
        "Marketing Investment & ROI Signals",
        "Marketing Channels by Segment",
        "Advertising & Media Spend",
      ],
    },
    {
      name: "Operations & Supply Chain",
      subDimensions: [
        "Quantitative Snapshot",
        "Capex Trends",
        "Inbound Logistics",
        "Raw Material Imports",
        "Tier 1 Suppliers",
        "Global Operations Network",
        "Cost Structure Analysis",
        "Trade Exposure",
        "Outbound Distribution",
        "Sustainability, Finance, Innovation, Risks",
        "Warehousing & Channels",
      ],
    },
    {
      name: "Corporate & Organizational Structure",
      subDimensions: [
        // "Business Segment",
        "Executive Leadership Team",
        // "Future Bets",
        "Executive Timeline",
        "Org Chart",
        // "Strategic Themes",
      ],
    },
  ],
  marketIqCompetitorProfileCategories: [
    {
      name: "Executive Snapshot",
      subDimensions: [
        "Company Overview",
        "Executive Summary Next Steps",
        "Overall Competitive Threat Assessment",
        "OpsSupply ScoreCard",
        "ProdInno ScoreCard",
        "MarketingDistributions ScoreCard",
        "OrgLeader ScoreCard",
        "FinancialsStrategy ScoreCard",
        "MarketPosition ScoreCard",
      ],
    },
    {
      name: "Product & Innovation",
      subDimensions: ["Innovation Theme Radar", "R&D Spend Estimates"],
    },
    {
      name: "Marketing & Distribution",
      subDimensions: ["GTM & Distribution Strategy Analysis"],
    },
    {
      name: "Operations & Supply Chain",
      subDimensions: [
        "Quantitative Snapshot",
        "Inbound Logistics",
        "Outbound Distribution",
        "Cost Structure Analysis",
        "Warehousing & Channels",
        "Raw Material Imports",
        "Global Operations Network",
      ],
    },
  ],

  METRICS_WITH_NAMES: {
    IQ_NI_CF: "Net Income Cash Flow",
    IQ_DA_SUPPL_CF: "Depreciation & Amort.",
    IQ_DA_CF: "Depreciation & Amort., Total",
    IQ_DO_CF: "Net Cash from Discontinued Ops.",
    IQ_OTHER_OPER_ACT: "Other Operating Activities",
    IQ_CHANGE_AR: "Change in Acc. Receivable",
    IQ_CHANGE_INVENTORY: "Change in Inventories",
    IQ_CHANGE_AP: "Change in Acc. Payable",
    IQ_CHANGE_INC_TAX: "Change in Inc. Taxes",
    IQ_CHANGE_OTHER_NET_OPER_ASSETS: "Change in Other Net Operating Assets",
    IQ_CASH_OPER: "Cash from Operations",
    IQ_CAPEX: "Capital Expenditure",
    IQ_SALE_PPE_CF: "Sale of Property, Plant and Equipment",
    IQ_CASH_ACQUIRE_CF: "Cash Acquisitions",
    IQ_DIVEST_CF: "Divestitures",
    IQ_INVEST_SECURITY_CF: "Invest. In Marketable & Equity Securities",
    IQ_INVEST_LOANS_CF:
      "Net (Increase) Dec. in Loans Originated/Sold - Investing",
    IQ_OTHER_INVEST_ACT_SUPPL: "Other Investing Activities",
    IQ_CASH_INVEST: "Cash from Investing",
    IQ_ST_DEBT_ISSUED: "Short-Term Debt Issued",
    IQ_LT_DEBT_ISSUED: "Long-Term Debt Issued",
    IQ_TOTAL_DEBT_ISSUED: "Total Debt Issued",
    IQ_ST_DEBT_REPAID: "Short-Term Debt Repaid",
    IQ_LT_DEBT_REPAID: "Long-Term Debt Repaid",
    IQ_TOTAL_DEBT_REPAID: "Total Debt Repaid",
    IQ_COMMON_REP: "Repurchase of Common Stock",
    IQ_COMMON_DIV_CF: "Common Dividends Paid",
    IQ_TOTAL_DIV_PAID_CF: "Total Dividends Paid",
    IQ_SPECIAL_DIV_CF: "Special Dividend Paid",
    IQ_OTHER_FINANCE_ACT_SUPPL: "Other Financing Activities",
    IQ_CASH_FINAN: "Cash from Financing",
    IQ_FX: "Foreign Exchange Rate Adj.",
    IQ_NET_CHANGE: "Net Change in Cash",
    IQ_CASH_INTEREST: "Cash Interest Paid",
    IQ_CASH_TAXES: "Cash Taxes Paid",
    IQ_LEVERED_CF: "Levered Free Cash Flow",
    IQ_UNLEVERED_FCF: "Unlevered Free Cash Flow",
    IQ_CHANGE_NET_WORKING_CAPITAL: "Change in Net Working Capital",
    IQ_NET_DEBT_ISSUED: "Net Debt Issued",
    IQ_FILINGDATE_CF: "Filing Date",

    IQ_RETURN_ASSETS: "Return on Assets %",
    IQ_RETURN_CAPITAL: "Return on Capital %",
    IQ_RETURN_EQUITY: "Return on Equity %",
    IQ_RETURN_COMMON_EQUITY: "Return on Common Equity %",
    IQ_GROSS_MARGIN: "Gross Margin %",
    IQ_EBITDA_MARGIN: "EBITDA Margin %",
    IQ_EBITA_MARGIN: "EBITA Margin%",
    IQ_EBIT_MARGIN: "EBIT Margin%",
    IQ_NI_MARGIN: "Net Income Margin %",
    IQ_ASSET_TURNS: "Total Asset Turnover",
    IQ_CURRENT_RATIO: "Current Ratio",
    IQ_QUICK_RATIO: "Quick Ratio",
    IQ_TOTAL_DEBT_EQUITY: "Total Debt/Equity",
    IQ_TOTAL_DEBT_CAPITAL: "Total Debt/Capital",
    IQ_TOTAL_LIAB_TOTAL_ASSETS: "Total Liabilities/Total Assets",
    IQ_TOTAL_DEBT_EBITDA: "Total Debt/EBITDA",
    IQ_TOTAL_REV_5YR_ANN_CAGR:
      "Total Revenue Growth Over Prior Year %, Growth Over Five Years %",
    IQ_GP_5YR_ANN_CAGR:
      "Gross Profit Growth Over Prior Year %, Growth Over Five Years %",
    IQ_EBITDA_5YR_ANN_CAGR:
      "EBITDA Growth Over Prior Year %, Growth Over Five Years %",
    IQ_EBITA_5YR_ANN_CAGR:
      "EBITA Growth Over Prior Year %, Growth Over Five Years %",
    IQ_EBIT_5YR_ANN_CAGR:
      "EBIT Growth Over Prior Year %, Growth Over Five Years %",
    IQ_NI_5YR_ANN_CAGR:
      "Net Income Growth Over Prior Year %, Growth Over Five Years %",
    IQ_TOTAL_ASSETS_5YR_ANN_CAGR:
      "Total Assets Growth Over Prior Year %, Growth Over Five Years %",

    IQ_CASH_EQUIV: "Cash and Equivalents",
    IQ_TRADING_ASSETS: "Trading Asset Securities",
    IQ_CASH_ST_INVEST: "Total Cash And Short Term Investments",
    IQ_AR: "Accounts Receivable",
    IQ_TOTAL_RECEIV: "Total Receivables",
    IQ_INVENTORY: "Inventory",
    IQ_PREPAID_EXP: "Prepaid Exp.",
    IQ_DEF_TAX_ASSETS_CURRENT: "Deferred Tax Assets, Curr.",
    IQ_OTHER_CA_SUPPL: "Other Current Assets",
    IQ_TOTAL_CA: "Total Current Assets",
    IQ_GPPE: "Gross Property, Plant & Equipment",
    IQ_AD: "Accumulated Depreciation",
    IQ_NPPE: "Net Property, Plant & Equipment",
    IQ_LT_INVEST: "Long-Term Investments",
    IQ_GW: "Goodwill",
    IQ_DEF_TAX_ASSETS_LT: "Deferred Tax Assets, LT",
    IQ_OTHER_LT_ASSETS: "Other Long-Term Assets",
    IQ_TOTAL_ASSETS: "Total Assets",
    IQ_AP: "Accounts Payable",
    IQ_AE: "Accrued Exp.",
    IQ_ST_DEBT: "Short-Term Borrowings",
    IQ_CURRENT_PORT_DEBT: "Curr. Port. of LT Debt",
    IQ_CURRENT_PORT_LEASES: "Curr. Port. Of Cap. Leases",
    IQ_INC_TAX_PAY_CURRENT: "Curr. Income Taxes Payable",
    IQ_OTHER_CL: "Other Current Liabilities",
    IQ_TOTAL_CL: "Total Current Liabilities",
    IQ_LT_DEBT: "Long-Term Debt",
    IQ_CAPITAL_LEASES: "Capital Leases",
    IQ_PENSION: "Pension & Other Post-Retire Benefits",
    IQ_DEF_TAX_LIAB_LT: "Def. Tax Liability, Non. Current",
    IQ_OTHER_LIAB_LT: "Other Non-Current Liabilities",
    IQ_TOTAL_LIAB: "Total Liabilities",
    IQ_COMMON: "Common Stock",
    IQ_APIC: "Additional Paid in Capital",
    IQ_RE: "Retained Earnings",
    IQ_TREASURY: "Treasury Stock",
    IQ_OTHER_EQUITY: "Comprehensive Inc. and Other",
    IQ_TOTAL_COMMON_EQUITY: "Total Common Equity",
    IQ_MINORITY_INTEREST: "Minority Interest ",
    IQ_TOTAL_EQUITY: "Total Equity",
    IQ_TOTAL_LIAB_EQUITY: "Total Liabilities And Equity",
    IQ_TOTAL_OUTSTANDING_FILING_DATE: "Total Shares Out. On Filing Date",
    IQ_TOTAL_OUTSTANDING_BS_DATE: "Total Shares Out. On Balance Sheet Date",
    IQ_BV_SHARE: "Book/Value Share",
    IQ_TBV: "Tangible Book Value",
    IQ_TBV_SHARE: "Tangible Book Value/Share",
    IQ_TOTAL_DEBT: "Total Debt",
    IQ_NET_DEBT: "Net Debt",
    IQ_DEBT_EQUIV_OPER_LEASE: "Debt Equivalent Oper. Leases",
    IQ_MINORITY_INTEREST_TOTAL: "Total Minority Interest",
    IQ_INV_METHOD: "Inventory Method",
    IQ_LAND: "Land",
    IQ_BUILDINGS: "Buildings",
    IQ_MACHINERY: "Machinery",
    IQ_CIP: "Construction in Progress",
    IQ_FULL_TIME: "Full Time Employees",
    IQ_ASSETS_CAP_LEASE_GROSS: "Assets Under Cap. Lease, Gross",
    IQ_ASSETS_CAP_LEASE_DEPR: "Assets Under Cap. Lease, Accum. Depr.",
    IQ_ALLOW_DOUBT_ACCT: "Accum. Allowance for Doubtful Accts",
    IQ_FILINGDATE_BS: "Filing Date",

    IQ_REV: "Revenue",
    IQ_OTHER_REV: "Other Revenue",
    IQ_TOTAL_REV: "Total Revenue",
    IQ_COGS: "Cost of Goods Sold",
    IQ_GP: "Gross Profit",
    IQ_SGA: "Selling General & Admin Exp.",
    IQ_RD_EXP: "R&D Exp.",
    IQ_DA: "Depreciation & Amortization",
    IQ_OTHER_OPER: "Other Operating Expenses/(Income)",
    IQ_TOTAL_OTHER_OPER: "Other Operating Expenses, Total",
    IQ_OPER_INC: "Operating Income",
    IQ_INTEREST_EXP: "Interest Expense",
    IQ_INTEREST_INVEST_INC: "Interest and Invest. Income",
    IQ_NET_INTEREST_EXP: "Net Interest Expenses",
    IQ_OTHER_NON_OPER_EXP_SUPPL: "Other Non Operating Inc. (Exp.)",
    IQ_EBT_EXCL: "EBT Excl. Unusual Items",
    IQ_RESTRUCTURE: "Restructuring Charges",
    IQ_IMPAIRMENT_GW: "Impairment of Goodwill",
    IQ_OTHER_UNUSUAL: "Other Unusual Items",
    IQ_EBT: "EBT Incl. Unusual Items",
    IQ_INC_TAX: "Income Tax Expenses",
    IQ_EARNING_CO: "Earnings From Continuing Operations",
    IQ_DO: "Earnings of Discontinued Ops.",
    IQ_EXTRA_ACC_ITEMS: "Extraordinary Item & Account Change",
    IQ_NI_COMPANY: "Net Income to Company",
    IQ_MINORITY_INTEREST_IS: "Minority Int. in Earnings",
    IQ_NI: "Net Income",
    IQ_PREF_DIV_OTHER: "Pref. Dividends and Other Adj.",
    IQ_NI_AVAIL_INCL: "Net Income to Common Incl Extra Items",
    IQ_NI_AVAIL_EXCL: "Net Income to Common Excl Extra Items",
    IQ_BASIC_EPS_INCL: "Basic EPS",
    IQ_BASIC_EPS_EXCL: "Basic EPS Excl. Extra Items",
    IQ_BASIC_WEIGHT: "Weighted Avg. Basic Shares Out.",
    IQ_DILUT_EPS_INCL: "Diluted EPS",
    IQ_DILUT_EPS_EXCL: "Diluted EPS Excl. Extra Items",
    IQ_DILUT_WEIGHT: "Weighted Avg. Diluted Shares Out.",
    IQ_EPS_NORM: "Normalized Basic EPS",
    IQ_DILUT_EPS_NORM: "Normalized Diluted EPS",
    IQ_DIV_SHARE: "Dividends Per Share",
    IQ_PAYOUT_RATIO: "Payout Ratio %",
    IQ_EBITA: "EBITA",
    IQ_EBITDAR: "EBITDAR",
    IQ_TOTAL_REV_AS_REPORTED: "As Reported Total Revenue",
    IQ_EFFECTIVE_TAX_RATE: "Effective Tax Rate %",
    IQ_CURR_DOMESTIC_TAXES: "Current Domestic Taxes",
    IQ_CURR_FOREIGN_TAXES: "Current Foreign Taxes",
    IQ_CURR_TAXES: "Total Current Taxes",
    IQ_DEFERRED_DOMESTIC_TAXES: "Deferred Domestic Taxes",
    IQ_DEFERRED_FOREIGN_TAXES: "Deferred Foreign Taxes",
    IQ_DEFERRED_TAXES_TOTAL: "Total Deferred Taxes",
    IQ_NI_NORM: "Normalized Net Income",
    IQ_CAPITALIZED_INTEREST: "Interest Capitalized",
    IQ_INT_EXP_LTD: "Interest on Long Term Debt",
    IQ_NONCASH_PENSION_EXP: "Non-Cash Pension Expense",
    IQ_ADVERTISING: "Advertising Exp.",
    IQ_SALES_MARKETING: "Selling and Marketing Exp.",
    IQ_NET_RENTAL_EXP: "Net Rental Exp.",
    IQ_IMPUT_OPER_LEASE_INT_EXP: "Imputed Oper. Lease Interest Exp.",
    IQ_IMPUT_OPER_LEASE_DEPR: "Imputed Oper. Lease Depreciation",
    IQ_STOCK_BASED_SGA: "Stock-Based Comp, SG&A Exp.",
    IQ_STOCK_BASED_TOTAL: "Stock-Based Comp, Total",
    IQ_FILINGDATE_IS: "Filing Date",
  },

  METRIC_GROUPS: {
    "Cash Flow": [
      "IQ_NI_CF",
      "IQ_DA_SUPPL_CF",
      "IQ_DA_CF",
      "IQ_DO_CF",
      "IQ_OTHER_OPER_ACT",
      "IQ_CHANGE_AR",
      "IQ_CHANGE_INVENTORY",
      "IQ_CHANGE_AP",
      "IQ_CHANGE_INC_TAX",
      "IQ_CHANGE_OTHER_NET_OPER_ASSETS",
      "IQ_CASH_OPER",
      "IQ_CAPEX",
      "IQ_SALE_PPE_CF",
      "IQ_CASH_ACQUIRE_CF",
      "IQ_DIVEST_CF",
      "IQ_INVEST_SECURITY_CF",
      "IQ_INVEST_LOANS_CF",
      "IQ_OTHER_INVEST_ACT_SUPPL",
      "IQ_CASH_INVEST",
      "IQ_ST_DEBT_ISSUED",
      "IQ_LT_DEBT_ISSUED",
      "IQ_TOTAL_DEBT_ISSUED",
      "IQ_ST_DEBT_REPAID",
      "IQ_LT_DEBT_REPAID",
      "IQ_TOTAL_DEBT_REPAID",
      "IQ_COMMON_REP",
      "IQ_COMMON_DIV_CF",
      "IQ_TOTAL_DIV_PAID_CF",
      "IQ_SPECIAL_DIV_CF",
      "IQ_OTHER_FINANCE_ACT_SUPPL",
      "IQ_CASH_FINAN",
      "IQ_FX",
      "IQ_NET_CHANGE",
      "IQ_CASH_INTEREST",
      "IQ_CASH_TAXES",
      "IQ_LEVERED_CF",
      "IQ_UNLEVERED_FCF",
      "IQ_CHANGE_NET_WORKING_CAPITAL",
      "IQ_NET_DEBT_ISSUED",
      "IQ_FILINGDATE_CF",
    ],

    Ratios: [
      "IQ_RETURN_ASSETS",
      "IQ_RETURN_CAPITAL",
      "IQ_RETURN_EQUITY",
      "IQ_RETURN_COMMON_EQUITY",
      "IQ_GROSS_MARGIN",
      "IQ_EBITDA_MARGIN",
      "IQ_EBITA_MARGIN",
      "IQ_EBIT_MARGIN",
      "IQ_NI_MARGIN",
      "IQ_ASSET_TURNS",
      "IQ_CURRENT_RATIO",
      "IQ_QUICK_RATIO",
      "IQ_TOTAL_DEBT_EQUITY",
      "IQ_TOTAL_DEBT_CAPITAL",
      "IQ_TOTAL_LIAB_TOTAL_ASSETS",
      "IQ_TOTAL_DEBT_EBITDA",
      "IQ_TOTAL_REV_5YR_ANN_CAGR",
      "IQ_GP_5YR_ANN_CAGR",
      "IQ_EBITDA_5YR_ANN_CAGR",
      "IQ_EBITA_5YR_ANN_CAGR",
      "IQ_EBIT_5YR_ANN_CAGR",
      "IQ_NI_5YR_ANN_CAGR",
      "IQ_TOTAL_ASSETS_5YR_ANN_CAGR",
    ],

    "Balance Sheet": [
      "IQ_CASH_EQUIV",
      "IQ_TRADING_ASSETS",
      "IQ_CASH_ST_INVEST",
      "IQ_AR",
      "IQ_TOTAL_RECEIV",
      "IQ_INVENTORY",
      "IQ_PREPAID_EXP",
      "IQ_DEF_TAX_ASSETS_CURRENT",
      "IQ_OTHER_CA_SUPPL",
      "IQ_TOTAL_CA",
      "IQ_GPPE",
      "IQ_AD",
      "IQ_NPPE",
      "IQ_LT_INVEST",
      "IQ_GW",
      "IQ_DEF_TAX_ASSETS_LT",
      "IQ_OTHER_LT_ASSETS",
      "IQ_TOTAL_ASSETS",
      "IQ_AP",
      "IQ_AE",
      "IQ_ST_DEBT",
      "IQ_CURRENT_PORT_DEBT",
      "IQ_CURRENT_PORT_LEASES",
      "IQ_INC_TAX_PAY_CURRENT",
      "IQ_OTHER_CL",
      "IQ_TOTAL_CL",
      "IQ_LT_DEBT",
      "IQ_CAPITAL_LEASES",
      "IQ_PENSION",
      "IQ_DEF_TAX_LIAB_LT",
      "IQ_OTHER_LIAB_LT",
      "IQ_TOTAL_LIAB",
      "IQ_COMMON",
      "IQ_APIC",
      "IQ_RE",
      "IQ_TREASURY",
      "IQ_OTHER_EQUITY",
      "IQ_TOTAL_COMMON_EQUITY",
      "IQ_MINORITY_INTEREST",
      "IQ_TOTAL_EQUITY",
      "IQ_TOTAL_LIAB_EQUITY",
      "IQ_TOTAL_OUTSTANDING_FILING_DATE",
      "IQ_TOTAL_OUTSTANDING_BS_DATE",
      "IQ_BV_SHARE",
      "IQ_TBV",
      "IQ_TBV_SHARE",
      "IQ_TOTAL_DEBT",
      "IQ_NET_DEBT",
      "IQ_DEBT_EQUIV_OPER_LEASE",
      "IQ_MINORITY_INTEREST_TOTAL",
      "IQ_INV_METHOD",
      "IQ_LAND",
      "IQ_BUILDINGS",
      "IQ_MACHINERY",
      "IQ_CIP",
      "IQ_FULL_TIME",
      "IQ_ASSETS_CAP_LEASE_GROSS",
      "IQ_ASSETS_CAP_LEASE_DEPR",
      "IQ_ALLOW_DOUBT_ACCT",
      "IQ_FILINGDATE_BS",
    ],

    "Key Statistics": [
      "IQ_COMMON",
      "IQ_DILUT_EPS_INCL",
      "IQ_EARNING_CO",
      "IQ_EBIT",
      "IQ_EBITDA",
      "IQ_GP",
      "IQ_CLOSEPRICE*",
      "IQ_MARKETCAP*",
      "IQ_NI",
      "IQ_SHARESOUTSTANDING*",
      "IQ_TOTAL_ASSETS",
      "IQ_TOTAL_CAP",
      "IQ_CAPEX",
      "IQ_TOTAL_DEBT",
      "IQ_DA",
    ],

    "Income Statement": [
      "IQ_TEV",
      "IQ_TOTAL_LIAB",
      "IQ_TOTAL_REV",
      "IQ_REV",
      "IQ_OTHER_REV",
      "IQ_COGS",
      "IQ_GP",
      "IQ_SGA",
      "IQ_RD_EXP",
      "IQ_DA",
      "IQ_OTHER_OPER",
      "IQ_TOTAL_OTHER_OPER",
      "IQ_OPER_INC",
      "IQ_INTEREST_EXP",
      "IQ_INTEREST_INVEST_INC",
      "IQ_NET_INTEREST_EXP",
      "IQ_OTHER_NON_OPER_EXP_SUPPL",
      "IQ_EBT_EXCL",
      "IQ_RESTRUCTURE",
      "IQ_IMPAIRMENT_GW",
      "IQ_OTHER_UNUSUAL",
      "IQ_EBT",
      "IQ_INC_TAX",
      "IQ_EARNING_CO",
      "IQ_DO",
      "IQ_EXTRA_ACC_ITEMS",
      "IQ_NI_COMPANY",
      "IQ_MINORITY_INTEREST_IS",
      "IQ_NI",
      "IQ_PREF_DIV_OTHER",
      "IQ_NI_AVAIL_INCL",
      "IQ_NI_AVAIL_EXCL",
      "IQ_BASIC_EPS_INCL",
      "IQ_BASIC_EPS_EXCL",
      "IQ_BASIC_WEIGHT",
      "IQ_DILUT_EPS_INCL",
      "IQ_DILUT_EPS_EXCL",
      "IQ_DILUT_WEIGHT",
      "IQ_EPS_NORM",
      "IQ_DILUT_EPS_NORM",
      "IQ_DIV_SHARE",
      "IQ_PAYOUT_RATIO",
      "IQ_EBITA",
      "IQ_EBITDAR",
      "IQ_TOTAL_REV_AS_REPORTED",
      "IQ_EFFECTIVE_TAX_RATE",
      "IQ_CURR_DOMESTIC_TAXES",
      "IQ_CURR_FOREIGN_TAXES",
      "IQ_CURR_TAXES",
      "IQ_DEFERRED_DOMESTIC_TAXES",
      "IQ_DEFERRED_FOREIGN_TAXES",
      "IQ_DEFERRED_TAXES_TOTAL",
      "IQ_NI_NORM",
      "IQ_CAPITALIZED_INTEREST",
      "IQ_INT_EXP_LTD",
      "IQ_NONCASH_PENSION_EXP",
      "IQ_ADVERTISING",
      "IQ_SALES_MARKETING",
      "IQ_NET_RENTAL_EXP",
      "IQ_IMPUT_OPER_LEASE_INT_EXP",
      "IQ_IMPUT_OPER_LEASE_DEPR",
      "IQ_STOCK_BASED_SGA",
      "IQ_STOCK_BASED_TOTAL",
      "IQ_FILINGDATE_IS",
    ],
  },

  ALL_METRICS: [
    // CASH FLOW
    "IQ_NI_CF",
    "IQ_DA_SUPPL_CF",
    "IQ_DA_CF",
    "IQ_DO_CF",
    "IQ_OTHER_OPER_ACT",
    "IQ_CHANGE_AR",
    "IQ_CHANGE_INVENTORY",
    "IQ_CHANGE_AP",
    "IQ_CHANGE_INC_TAX",
    "IQ_CHANGE_OTHER_NET_OPER_ASSETS",
    "IQ_CASH_OPER",
    "IQ_CAPEX",
    "IQ_SALE_PPE_CF",
    "IQ_CASH_ACQUIRE_CF",
    "IQ_DIVEST_CF",
    "IQ_INVEST_SECURITY_CF",
    "IQ_INVEST_LOANS_CF",
    "IQ_OTHER_INVEST_ACT_SUPPL",
    "IQ_CASH_INVEST",
    "IQ_ST_DEBT_ISSUED",
    "IQ_LT_DEBT_ISSUED",
    "IQ_TOTAL_DEBT_ISSUED",
    "IQ_ST_DEBT_REPAID",
    "IQ_LT_DEBT_REPAID",
    "IQ_TOTAL_DEBT_REPAID",
    "IQ_COMMON_REP",
    "IQ_COMMON_DIV_CF",
    "IQ_TOTAL_DIV_PAID_CF",
    "IQ_SPECIAL_DIV_CF",
    "IQ_OTHER_FINANCE_ACT_SUPPL",
    "IQ_CASH_FINAN",
    "IQ_FX",
    "IQ_NET_CHANGE",
    "IQ_CASH_INTEREST",
    "IQ_CASH_TAXES",
    "IQ_LEVERED_CF",
    "IQ_UNLEVERED_FCF",
    "IQ_CHANGE_NET_WORKING_CAPITAL",
    "IQ_NET_DEBT_ISSUED",
    "IQ_FILINGDATE_CF",
    // RATIOS
    "IQ_RETURN_ASSETS",
    "IQ_RETURN_CAPITAL",
    "IQ_RETURN_EQUITY",
    "IQ_RETURN_COMMON_EQUITY",
    "IQ_GROSS_MARGIN",
    "IQ_EBITDA_MARGIN",
    "IQ_EBITA_MARGIN",
    "IQ_EBIT_MARGIN",
    "IQ_NI_MARGIN",
    "IQ_ASSET_TURNS",
    "IQ_CURRENT_RATIO",
    "IQ_QUICK_RATIO",
    "IQ_TOTAL_DEBT_EQUITY",
    "IQ_TOTAL_DEBT_CAPITAL",
    "IQ_TOTAL_LIAB_TOTAL_ASSETS",
    "IQ_TOTAL_DEBT_EBITDA",
    "IQ_TOTAL_REV_5YR_ANN_CAGR",
    "IQ_GP_5YR_ANN_CAGR",
    "IQ_EBITDA_5YR_ANN_CAGR",
    "IQ_EBITA_5YR_ANN_CAGR",
    "IQ_EBIT_5YR_ANN_CAGR",
    "IQ_NI_5YR_ANN_CAGR",
    "IQ_TOTAL_ASSETS_5YR_ANN_CAGR",
    // BALANCE SHEET
    "IQ_CASH_EQUIV",
    "IQ_TRADING_ASSETS",
    "IQ_CASH_ST_INVEST",
    "IQ_AR",
    "IQ_TOTAL_RECEIV",
    "IQ_INVENTORY",
    "IQ_PREPAID_EXP",
    "IQ_DEF_TAX_ASSETS_CURRENT",
    "IQ_OTHER_CA_SUPPL",
    "IQ_TOTAL_CA",
    "IQ_GPPE",
    "IQ_AD",
    "IQ_NPPE",
    "IQ_LT_INVEST",
    "IQ_GW",
    "IQ_DEF_TAX_ASSETS_LT",
    "IQ_OTHER_LT_ASSETS",
    "IQ_TOTAL_ASSETS",
    "IQ_AP",
    "IQ_AE",
    "IQ_ST_DEBT",
    "IQ_CURRENT_PORT_DEBT",
    "IQ_CURRENT_PORT_LEASES",
    "IQ_INC_TAX_PAY_CURRENT",
    "IQ_OTHER_CL",
    "IQ_TOTAL_CL",
    "IQ_LT_DEBT",
    "IQ_CAPITAL_LEASES",
    "IQ_PENSION",
    "IQ_DEF_TAX_LIAB_LT",
    "IQ_OTHER_LIAB_LT",
    "IQ_TOTAL_LIAB",
    "IQ_COMMON",
    "IQ_APIC",
    "IQ_RE",
    "IQ_TREASURY",
    "IQ_OTHER_EQUITY",
    "IQ_TOTAL_COMMON_EQUITY",
    "IQ_MINORITY_INTEREST",
    "IQ_TOTAL_EQUITY",
    "IQ_TOTAL_LIAB_EQUITY",
    "IQ_TOTAL_OUTSTANDING_FILING_DATE",
    "IQ_TOTAL_OUTSTANDING_BS_DATE",
    "IQ_BV_SHARE",
    "IQ_TBV",
    "IQ_TBV_SHARE",
    "IQ_TOTAL_DEBT",
    "IQ_NET_DEBT",
    "IQ_DEBT_EQUIV_OPER_LEASE",
    "IQ_MINORITY_INTEREST_TOTAL",
    "IQ_INV_METHOD",
    "IQ_LAND",
    "IQ_BUILDINGS",
    "IQ_MACHINERY",
    "IQ_CIP",
    "IQ_FULL_TIME",
    "IQ_ASSETS_CAP_LEASE_GROSS",
    "IQ_ASSETS_CAP_LEASE_DEPR",
    "IQ_ALLOW_DOUBT_ACCT",
    "IQ_FILINGDATE_BS",
    // KEY STATISTICS
    "IQ_COMMON",
    "IQ_DILUT_EPS_INCL",
    "IQ_EARNING_CO",
    "IQ_EBIT",
    "IQ_EBITDA",
    "IQ_GP",
    "IQ_CLOSEPRICE*",
    "IQ_MARKETCAP*",
    "IQ_NI",
    "IQ_SHARESOUTSTANDING*",
    "IQ_TOTAL_ASSETS",
    "IQ_TOTAL_CAP",
    "IQ_CAPEX",
    "IQ_TOTAL_DEBT",
    "IQ_DA",
    // INCOME STATEMENT
    "IQ_TEV",
    "IQ_TOTAL_LIAB",
    "IQ_TOTAL_REV",
    "IQ_REV",
    "IQ_OTHER_REV",
    "IQ_COGS",
    "IQ_GP",
    "IQ_SGA",
    "IQ_RD_EXP",
    "IQ_DA",
    "IQ_OTHER_OPER",
    "IQ_TOTAL_OTHER_OPER",
    "IQ_OPER_INC",
    "IQ_INTEREST_EXP",
    "IQ_INTEREST_INVEST_INC",
    "IQ_NET_INTEREST_EXP",
    "IQ_OTHER_NON_OPER_EXP_SUPPL",
    "IQ_EBT_EXCL",
    "IQ_RESTRUCTURE",
    "IQ_IMPAIRMENT_GW",
    "IQ_OTHER_UNUSUAL",
    "IQ_EBT",
    "IQ_INC_TAX",
    "IQ_EARNING_CO",
    "IQ_DO",
    "IQ_EXTRA_ACC_ITEMS",
    "IQ_NI_COMPANY",
    "IQ_MINORITY_INTEREST_IS",
    "IQ_NI",
    "IQ_PREF_DIV_OTHER",
    "IQ_NI_AVAIL_INCL",
    "IQ_NI_AVAIL_EXCL",
    "IQ_BASIC_EPS_INCL",
    "IQ_BASIC_EPS_EXCL",
    "IQ_BASIC_WEIGHT",
    "IQ_DILUT_EPS_INCL",
    "IQ_DILUT_EPS_EXCL",
    "IQ_DILUT_WEIGHT",
    "IQ_EPS_NORM",
    "IQ_DILUT_EPS_NORM",
    "IQ_DIV_SHARE",
    "IQ_PAYOUT_RATIO",
    "IQ_EBITA",
    "IQ_EBITDAR",
    "IQ_TOTAL_REV_AS_REPORTED",
    "IQ_EFFECTIVE_TAX_RATE",
    "IQ_CURR_DOMESTIC_TAXES",
    "IQ_CURR_FOREIGN_TAXES",
    "IQ_CURR_TAXES",
    "IQ_DEFERRED_DOMESTIC_TAXES",
    "IQ_DEFERRED_FOREIGN_TAXES",
    "IQ_DEFERRED_TAXES_TOTAL",
    "IQ_NI_NORM",
    "IQ_CAPITALIZED_INTEREST",
    "IQ_INT_EXP_LTD",
    "IQ_NONCASH_PENSION_EXP",
    "IQ_ADVERTISING",
    "IQ_SALES_MARKETING",
    "IQ_NET_RENTAL_EXP",
    "IQ_IMPUT_OPER_LEASE_INT_EXP",
    "IQ_IMPUT_OPER_LEASE_DEPR",
    "IQ_STOCK_BASED_SGA",
    "IQ_STOCK_BASED_TOTAL",
    "IQ_FILINGDATE_IS",
  ],

  CUSTOM_SELECT_STYLES: {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? "#f5f5f5" : "#fff",
      color: "#222",

      // prevent selected blue color
      ":active": {
        backgroundColor: "#f0f0f0",
        color: "#4e6bca",
      },
    }),
  },
};

export default APP_CONFIG;
